import axios from 'axios';

const capi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

capi.interceptors.request.use((config) => {
  const token = localStorage.getItem('colab_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

capi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && window.location.pathname.startsWith('/colaborador') && !window.location.pathname.includes('login')) {
      localStorage.removeItem('colab_token');
      window.location.href = '/colaborador';
    }
    return Promise.reject(err);
  }
);

export const colabApi = {
  login: (telefone, senha) => capi.post('/colab-portal/auth/login', { telefone, senha }),
  alterarSenha: (senha_atual, nova_senha) => capi.post('/colab-portal/auth/alterar-senha', { senha_atual, nova_senha }),
  me: () => capi.get('/colab-portal/me'),
  updatePerfil: (data) => capi.put('/colab-portal/perfil', data),
  servicos: () => capi.get('/colab-portal/servicos'),
  updateServicos: (servicos_ids) => capi.put('/colab-portal/servicos', { servicos_ids }),
  ordens: () => capi.get('/colab-portal/ordens'),
};
